import React, { lazy } from "react";

const LazyReassessments = lazy(() => import("./Reassessments"));

const Reassessments = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyReassessments {...props} />;

export default Reassessments;
